// app/javascript/hooks/useRanks.js
import { useState, useEffect, useCallback } from 'react';

export const DEFAULT_RANKS = [
  { id: 1, name: 'S/Guud:', somali_name: 'Sareeye Guud (General)' },
  { id: 2, name: 'S/Gaas:', somali_name: 'Sareeye Gaas (Major General)' },
  { id: 3, name: 'G/Sare:', somali_name: 'Gaashaanle Sare (Colonel)' },
  { id: 4, name: 'G/le:', somali_name: 'Gaashaanle (Major)' },
  { id: 5, name: 'Dhame', somali_name: 'Dhame (Captain)' },
  { id: 6, name: '2X/le:', somali_name: 'Laba Xiddigle (Lieutenant)' },
  { id: 7, name: 'X/Le:', somali_name: 'Xiddigle (Second Lieutenant)' },
  { id: 8, name: 'K/S:', somali_name: 'Kormeere Sare (Senior Inspector)' },
  { id: 9, name: 'K/L:', somali_name: 'Kormeere Labaad (Inspector)' },
  { id: 10, name: 'K/K:', somali_name: 'Kormeere Keliya (Junior Inspector)' },
  { id: 11, name: 'D/le:', somali_name: 'Dabaliye (Private / Soldier)' },
  { id: 12, name: 'N/A', somali_name: 'N/A' }
];

export const useRanks = (api) => {
  const [ranks, setRanks] = useState(DEFAULT_RANKS);
  const [loading, setLoading] = useState(false);

  const fetchRanks = useCallback(async () => {
    if (!api || !api.get) return;
    try {
      setLoading(true);
      const data = await api.get('/ranks');
      let rankList = [];
      if (Array.isArray(data)) {
        rankList = data;
      } else if (data && Array.isArray(data.ranks)) {
        rankList = data.ranks;
      }

      if (rankList.length > 0) {
        setRanks(rankList);
      }
    } catch (error) {
      console.warn('Failed to load ranks from API, using default list:', error);
    } finally {
      setLoading(false);
    }
  }, [api]);

  useEffect(() => {
    fetchRanks();
  }, [fetchRanks]);

  return {
    ranks,
    loading,
    refetchRanks: fetchRanks
  };
};
